export default "__VITE_ASSET__BDKsaW9i__"